<template>
    <div class="shopSetting">
        <div class="shopSettingTitle"><span class="erect">|</span> 基本信息</div>
        <div class="basicMsg">
            <!-- 店铺LOGO -->
            <div class="item">
                <div class="left">
                    <p class="title">店铺logo：</p>
                    <div class="LogoBox">
                        <div class="noLogo" v-if="!basicMsg.shoplogourl">
                            <img :src="require('common/images/other/icon_headImg@2x.png')" alt="">
                        </div>
                        <div class="haveLogo" v-else>
                            <img :src="basicMsg.shoplogourl" alt="">
                        </div>
                    </div>
                </div>
                <div class="right" @click="logoSet">设置</div>
            </div>
            <!-- 店铺名称 -->
            <div class="item">
                <div class="left">
                    <p class="title">店铺名称</p>
                    <div class="content" v-if="basicMsg.hostshopname">{{basicMsg.hostshopname}}</div>
                    <div v-else>-</div>
                </div>
                <div class="right" @click="nameSet">设置</div>
            </div>
            <!-- 移动端店铺地址 -->
            <div class="item">
                <div class="left">
                    <p class="title">店铺移动端地址 ：</p>
                    <div class="content" v-if="basicMsg.shopurlmobile">{{basicMsg.shopurlmobile}} <i class="el-icon-info"></i></div>
                    <div v-else>-</div>
                </div>
                <div class="right copyMobileLink" :data-clipboard-text="basicMsg.shopurlmobile" @click="copyMobileLink">复制链接</div>
            </div>
            <!-- 店铺PC端地址 -->
            <div class="item">
                <div class="left">
                    <p class="title">店铺PC端地址 ：</p>
                    <div class="content" v-if="basicMsg.shopurlpc">{{basicMsg.shopurlpc}} <i class="el-icon-info"></i></div>
                    <div v-else>-</div>
                </div>
                <div class="right copyPcLink" :data-clipboard-text="basicMsg.shopurlpc" @click="copyPCLink">复制链接</div>
            </div>
            <!-- 联系人手机 -->
            <div class="item">
                <div class="left">
                    <p class="title">联系人手机 ：</p>
                    <div class="content" v-if="basicMsg.linktel">{{basicMsg.linktel}}</div>
                    <div v-else>-</div>
                </div>
                <div class="right" @click="mobileNumSet">设置</div>
            </div>
            <!-- 联系地址 -->
            <div class="item">
                <div class="left">
                    <p class="title">联系地址 ：</p>
                    <div class="content" v-if="basicMsg.linkaddress">{{basicMsg.linkaddress}}</div>
                    <div v-else>-</div>
                </div>
                <div class="right" @click="addressSet">设置</div>
            </div>
            <!-- 店铺简介 -->
            <div class="item desp">
                <div class="left">
                    <p class="title">店铺简介 ：</p>
                    <div class="content" v-if="basicMsg.shopdesp">{{basicMsg.shopdesp}}</div>
                    <div v-else>-</div>
                </div>
                <div class="right" @click="descSet">设置</div>
            </div>
            <!-- 客服二维码 -->
            <div class="item">
                <div class="left">
                    <p class="title">客服二维码 ：</p>
                    <div class="content" v-if="basicMsg.serviceqrcodeurl"><img :src="basicMsg.serviceqrcodeurl" alt=""></div>
                    <div v-else>-</div>
                </div>
                <div class="right" @click="serviceCode">设置</div>
            </div>
        </div>
        <div class="shopSettingTitle"><span class="erect">|</span> 关注信息</div>
        <div class="attentionMsg">
            <!-- 引导关注二维码 -->
            <div class="item">
                <div class="left">
                    <p class="title">引导关注二维码：<i class="el-icon-info"></i> </p>
                    <div class="content" v-if="basicMsg.subqrcodeurl"><img :src="basicMsg.subqrcodeurl" alt=""><span>{{basicMsg.subqrcodename}}</span></div>
                    <div v-else>-</div>
                </div>
                <div class="right" @click="noBuyCode">设置</div>
            </div>
            <!-- 购买后关注二维码 -->
            <div class="item">
                <div class="left">
                    <p class="title">购买后关注二维码 <i class="el-icon-info"></i></p>
                    <div class="content" v-if="basicMsg.orderqrcodeurl"><img :src="basicMsg.orderqrcodeurl" alt=""><span>{{basicMsg.orderqrcodename}}</span></div>
                    <div v-else>-</div>
                </div>
                <div class="right" @click="buyCode">设置</div>
            </div>
        </div>
        <ShopLogo ref="shopLogo" @getMsg="getShopSetMsg" :data="basicMsg"></ShopLogo>
        <ShopDesc ref="shopDesc" @getMsg="getShopSetMsg" :data="basicMsg"></ShopDesc>
        <ShopPhone ref="shopPhone" @getMsg="getShopSetMsg" :data="basicMsg"></ShopPhone>
        <ShopName ref="shopName" @getMsg="getShopSetMsg" :data="basicMsg"></ShopName>
        <ServiceCode ref="serviceCode" @getMsg="getShopSetMsg" :data="basicMsg"></ServiceCode>
        <NoBuyCode ref="noBuyCode" @getMsg="getShopSetMsg" :data="basicMsg"></NoBuyCode>
        <buyCode ref="buyCode" @getMsg="getShopSetMsg" :data="basicMsg"></buyCode>
        <RelationAddress ref="relationAddress" @getMsg="getShopSetMsg" :data="basicMsg"></RelationAddress>

    </div>
</template>
<script>
import ShopLogo from './components/shopLogo'
import ShopDesc from './components/shopDesc'
import ShopPhone from './components/shopPhone'
import ShopName from './components/shopName'
import RelationAddress from './components/relationAddress'
import ServiceCode from './components/serviceCode'
import NoBuyCode from './components/noBuyCode'
import buyCode from './components/buyCode'
import {mapGetters, mapActions} from 'vuex'
import {getShopSetMsg} from '@/api/accountApi'
import Clipboard from 'clipboard'
export default {
    name: 'shopSetting',
    data() {
        return {
            basicMsg: {}
        }
    },
    created() {
        this.getShopSetMsg()
    },
    mounted() {
    },
    methods: {
        // 购买后二维码设置
        buyCode() {
            this.$refs.buyCode.centerDialogVisible = true
        },
        // 引导关注二维码设置
        noBuyCode() {
            this.$refs.noBuyCode.centerDialogVisible = true
        },
        // 客服二维码设置
        serviceCode() {
            this.$refs.serviceCode.centerDialogVisible = true
        },
        // 联系地址设置
        addressSet() {
            this.$refs.relationAddress.centerDialogVisible = true
        },
        // 联系人电话设置
        mobileNumSet() {
            this.$refs.shopPhone.centerDialogVisible = true
        },
        // 店铺简介设置
        descSet() {
            this.$refs.shopDesc.centerDialogVisible = true
        },
        // 店铺名称设置
        nameSet() {
            this.$refs.shopName.centerDialogVisible = true
        },
        // 店铺logo设置
        logoSet() {
            this.$refs.shopLogo.centerDialogVisible = true
        },
        getShopSetMsg() {
            this.setLoading(true)
            getShopSetMsg({
                data: {},
                success: data => {
                    this.setLoading(false)
                    this.basicMsg = data.data
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        // 复制PC链接
        copyPCLink() {
            var clipboard = new Clipboard('.copyPcLink')
            clipboard.on('success', e => {
                this.$message.success('复制成功')
                // 释放内存
                clipboard.destroy()
            })
            clipboard.on('error', e => {
                // 不支持复制
                this.$message.warning('该浏览器不支持自动复制')
                // 释放内存
                clipboard.destroy()
            })
        },
        // 复制移动链接
        copyMobileLink() {
            var clipboard = new Clipboard('.copyMobileLink')
            clipboard.on('success', e => {
                this.$message.success('复制成功')
                // 释放内存
                clipboard.destroy()
            })
            clipboard.on('error', e => {
                // 不支持复制
                this.$message.warning('该浏览器不支持自动复制')
                // 释放内存
                clipboard.destroy()
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
    },
    components: {
        ShopLogo, ShopDesc, ShopPhone, ShopName, RelationAddress, ServiceCode, NoBuyCode, buyCode
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/variable";
@import "~common/scss/mixin";
.shopSetting {
    .shopSettingTitle{
        font-size: 16px;
        font-weight: bold;
        .erect{
            position: relative;
            top: -1px;
            margin-right: 2px;
            color: #409EFF;
        }
    }
    .basicMsg, .attentionMsg{
        .item:not(:last-of-type) {
            border-bottom: 1px solid #DCDFE6;
        }
        .item{
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 20px 0;
            .left{
                display: flex;
                .title{
                    font-size: 14px;
                    font-weight: 400;
                    width: 130px;
                    margin-right: 72px;
                }
                .content{
                    font-size: 14px;
                    img{
                        width: 110px;
                        height: 110px;
                    }
                }
                .el-icon-info{
                    color: #C0C4CC;
                }
                .LogoBox{
                    .noLogo{
                        background: #F5F7FA;
                        img{
                            width: 80px;
                            height: 80px;
                        }
                    }
                    .haveLogo{
                        img{
                            width: 80px;
                            height: 80px;
                        }
                    }
                }
            }
            .right{
                color: #409EFF;
                cursor: pointer;
                margin-right: 20px;
            }
        }
        .desp{
            .content{
                width: 650px;
            }
        }
    }
    .attentionMsg{
        .item{
            .left{
                .content{
                    display: flex;
                    align-items: center;
                    span{
                        margin-left: 10px;
                    }
                }
            }
        }
    }
}
</style>
